/** @param {string} value */
export const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

export const SEARCH_HIGHLIGHT_CURRENT_CLASS =
  'rounded-sm bg-brand-200 px-0.5 font-medium ring-2 ring-inset ring-brand-600 dark:bg-brand-800 dark:ring-brand-400 highlight-current-js';
export const SEARCH_HIGHLIGHT_OTHER_CLASS =
  'rounded-sm bg-amber-100 px-0.5 dark:bg-amber-900/50';

const CLS_CURRENT = SEARCH_HIGHLIGHT_CURRENT_CLASS;
const CLS_OTHER = SEARCH_HIGHLIGHT_OTHER_CLASS;

export const buildHighlightedHtml = (content, matchesInMessage, currentMatchIndex) => {
  if (!matchesInMessage.length) return escapeHtml(content);
  let html = '';
  let lastEnd = 0;
  matchesInMessage.forEach(({ start, end, globalIndex }) => {
    if (start > lastEnd) {
      html += escapeHtml(content.slice(lastEnd, start));
    }
    const slice = escapeHtml(content.slice(start, end));
    const className = globalIndex === currentMatchIndex ? CLS_CURRENT : CLS_OTHER;
    html += `<span class="${className}">${slice}</span>`;
    lastEnd = end;
  });
  if (lastEnd < content.length) {
    html += escapeHtml(content.slice(lastEnd));
  }
  return html;
};

/**
 * Inserts highlight `<mark>` tags into markdown without escaping the rest of the string,
 * so {@link ChatMessageMarkdown} can still parse markdown + GFM (same approach as ann-web-app).
 * @param {string} content
 * @param {Array<{ start: number, end: number, globalIndex: number }>} matchesInMessage
 * @param {number} currentMatchIndex
 */
export const buildMarkdownWithHighlights = (content, matchesInMessage, currentMatchIndex) => {
  if (!content || !matchesInMessage.length) return content;
  const parts = [];
  let lastEnd = 0;
  matchesInMessage.forEach(({ start, end, globalIndex }) => {
    if (start > lastEnd) {
      parts.push(content.slice(lastEnd, start));
    }
    const slice = content.slice(start, end);
    const className = globalIndex === currentMatchIndex ? CLS_CURRENT : CLS_OTHER;
    parts.push(`<mark class="${className}">${escapeHtml(slice)}</mark>`);
    lastEnd = end;
  });
  if (lastEnd < content.length) {
    parts.push(content.slice(lastEnd));
  }
  return parts.join('');
};
